import { GET_AUTH } from '@/services/api/auth'
import { GET_VEHICLE_GROUPS } from '@/services/api/setting/fleet/fleetGroup'
import { client } from '@/services/apolloclient'
import store from '@/state/store'

export const Auth = {
  methods: {
    async getAuth() {
      await client
        .query({
          fetchPolicy: 'no-cache',
          query: GET_AUTH,
        })
        .then(({ data }) => {
          const validEnvironments = ['production', 'staging', 'development']
          const currentEnv = process.env.VUE_APP_ENV
          const ENV_URL = process.env.VUE_APP_URL.replace('https://', '')

          if (data.auth.isSuccessful) {
            store.commit('access/SET_DATA', data.auth.auth)

            if (
              validEnvironments.includes(currentEnv) &&
              window.location.host !== data.auth.auth.company.domainName &&
              window.location.host !== ENV_URL
            ) {
              window.location.href = `${window.location.protocol}//${data.auth.auth.company.domainName}${window.location.pathname}${window.location.search}`
            }
          } else {
            location.href = `${process.env.BASE_URL}logout`
          }
        })
        .catch((err) => {
          if (err) {
            location.href = `${process.env.BASE_URL}logout`
          }
        })
    },

    async getVgroups() {
      await client
        .query({
          fetchPolicy: 'no-cache',
          query: GET_VEHICLE_GROUPS,
        })
        .then(({ data }) => {
          if (data.vgroups.isSuccessful) {
            store.commit('access/SET_VGROUPS', data.vgroups.vgroups)
          }
        })
    },
  },
}
